<template>
 <v-container >
  <v-layout row wrap>
    <v-flex xs12 sm3 >
      <div style="position:sticky; top:55px; z-index:1;">

      <div class="add-page-head">
        <span :class="{'display-4 section-head d-block' : $vuetify.breakpoint.xsOnly, 'display-3 section-head d-block' : !$vuetify.breakpoint.xsOnly}">Help</span>
        <span class="body-small font-weight-bold pt-1 d-block">Contact and Faq</span>
      </div>
      <div class="" >
        <div class="faqlinks sticky lg:top-[90px]">
          <nav>
             <router-link to="/support" class="body-2 d-block py-2 fadegrey--text" >Contact Us</router-link>
             <router-link to="/support/faqs" class="body-1 d-block py-2 fadegrey--text" >FAQ</router-link>
          </nav>
        </div>
      </div>
      </div>
    </v-flex>
    <v-flex xs12 sm9 style="margin-top:30px;">
      <v-layout :class="{'pt-0' : $vuetify.breakpoint.xsOnly, 'pt-5 mt-5' : !$vuetify.breakpoint.xsOnly}">
        <v-flex xs12 sm11 offset-sm1>
          <v-layout>
          <v-flex xs12 mt-2>
            <div class="app-panel white py-4 faqs" :class="{'px-4' : $vuetify.breakpoint.xsOnly, 'px-5' : !$vuetify.breakpoint.xsOnly}">
              <span class="subheading mb-3">FAQ</span>
              <v-layout align-start row fill-height wrap>
                  <v-flex xs12 md8>
                    <p>The answers to the most commonly asked questions can be found quickly in our <a href="/support/faqs">FAQ</a>.  Alternatively get in touch directly using our Contact form below.</p>
                  </v-flex>
                  <v-flex xs12 md3 offset-md1 >
                    <v-btn href="/support/faqs" block depressed color="primary" type="submit" :disabled="loading" >
                     View FAQ
                    </v-btn>
                  </v-flex>
                </v-layout>
            </div>
          </v-flex>
          </v-layout>
          <v-layout>
          <v-flex xs12 mt-4>
            <div class="app-panel white py-4 faqs" :class="{'px-4' : $vuetify.breakpoint.xsOnly, 'px-5' : !$vuetify.breakpoint.xsOnly}">
              <span class="subheading">Contact us</span>
               <v-form v-model="emailvalid" ref="emailForm" v-if="!formSubmitted">
                <v-select
                        placeholder=" "
                        :items="enquiries"
                        label="Type of enquiry"
                        v-model="yourEnquiryType"
                        :rules="[input_required]"
                        ></v-select>
                  <v-text-field
                     name="yourName"
                     label="Your name"
                     v-model="yourName"
                     placeholder=" "
                     :rules="[input_required]"
                     ></v-text-field>
                  <v-text-field
                     name="yourEmail"
                     label="Your email"
                     v-model="yourEmail"
                     placeholder=" "
                     :rules="[emailRules]"
                     ></v-text-field>
                     <v-textarea
                      name="yourMessage"
                      label="Your message"
                      v-model="yourMessage"
                      auto-grow
                      placeholder=" "
                      rows="5"
                      :rules="[input_required]"
                      ></v-textarea>
                      <v-btn class="mt-1" depressed  color="primary" @click="onSendEmail" :disabled='!emailvalid' :loading="loading">Send</v-btn>
               </v-form>
               <div v-else class="pb-3 mb-3 text-xs-center">
                <div class="animation-ctn">
                <div class="icon icon--order-success svg" style="">
                  <svg xmlns="http://www.w3.org/2000/svg" width="154px" height="154px">
                    <g fill="none" stroke="#73BA20" stroke-width="2">
                      <circle cx="77" cy="77" r="72" style="stroke-dasharray:480px, 480px; stroke-dashoffset: 960px;"></circle>
                      <circle id="colored" fill="#73BA20" cx="77" cy="77" r="72" style="stroke-dasharray:480px, 480px; stroke-dashoffset: 960px;"></circle>
                      <polyline class="st0" stroke="#fff" stroke-width="10" points="43.5,77.8 63.7,97.9 112.2,49.4 " style="stroke-dasharray:100px, 100px; stroke-dashoffset: 200px;"/>
                    </g>
                  </svg>
                </div>
</div>
                <p class="body-2">Success! We'll get back to you soon.</p>

                  <a @click="formSubmitted = false" class="text-decoration-underline">Click here to send another email.</a>

               </div>
            </div>
          </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</v-container>
</template>
<script>

import firebase from 'firebase/app'
import 'firebase/functions'

export default {
  data () {
    return {
      group: this.$store.getters.group,
      yourName: '',
      yourEmail: this.$store.getters.user.email,
      yourMessage: '',
      emailvalid: false,
      yourEnquiryType: 'Support',
      formSubmitted: false,
      enquiries: [
        'Support',
        'Feature request',
        'Feedback'
      ],
      input_required: value => !!value || 'Required.',
      // emailRules: v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
      emailRules: v => /.+@.+\..+/.test(v) || 'E-mail must be valid'

    }
  },
  computed: {
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  methods: {
    onDismissed () {
      this.$store.dispatch('clearError')
    },
    async onSendEmail () {
      this.$store.commit('setLoading', true)
      this.formSubmitted = true
      const email = {
        to: 'support@tryworktabs.com',
        subject: 'WorkTabs enquiry' + ' - ' + this.yourEnquiryType,
        body: 'You have a new enquiry from ' + this.yourName + ' (' + this.yourEmail + ')<br><br>' + this.yourMessage
      }
      try {
        const sendEmail = firebase.functions().httpsCallable('sendEmail')
        const response = await sendEmail(email)
        this.$store.commit('setLoading', false)
        return response
      } catch (error) {
        this.$store.commit('setLoading', false)
      }
    }
  }
}
</script>
<style lang="scss">
.faqs{
  scroll-behavior: smooth;
}
.faqlinks a{
  text-decoration: none;
  &:focus{
      font-weight:700;
  }
}
h2.faq-title {
  margin-bottom:15px;
  margin-top:35px;
}

.animation-ctn{
  text-align:center;
}
.icon--order-success{
  // scale .5
  transform: scale(0.5);
}

@-webkit-keyframes checkmark {
    0% {
        stroke-dashoffset: 100px
    }

    100% {
        stroke-dashoffset: 200px
    }
}

@-ms-keyframes checkmark {
    0% {
        stroke-dashoffset: 100px
    }

    100% {
        stroke-dashoffset: 200px
    }
}

@keyframes checkmark {
    0% {
        stroke-dashoffset: 100px
    }

    100% {
        stroke-dashoffset: 0px
    }
}

@-webkit-keyframes checkmark-circle {
    0% {
        stroke-dashoffset: 480px
    }

    100% {
        stroke-dashoffset: 960px;
    }
}

@-ms-keyframes checkmark-circle {
    0% {
        stroke-dashoffset: 240px
    }

    100% {
        stroke-dashoffset: 480px
    }
}

@keyframes checkmark-circle {
    0% {
        stroke-dashoffset: 480px
    }

    100% {
        stroke-dashoffset: 960px
    }
}

@keyframes colored-circle {
    0% {
        opacity:0
    }

    100% {
        opacity:100
    }
}

/* other styles */
/* .svg svg {
    display: none
}
 */
.inlinesvg .svg svg {
    display: inline
}

/* .svg img {
    display: none
} */

.icon--order-success svg polyline {
    -webkit-animation: checkmark 0.25s ease-in-out 0.7s backwards;
    animation: checkmark 0.25s ease-in-out 0.7s backwards
}

.icon--order-success svg circle {
    -webkit-animation: checkmark-circle 0.6s ease-in-out backwards;
    animation: checkmark-circle 0.6s ease-in-out backwards;
}
.icon--order-success svg circle#colored {
    -webkit-animation: colored-circle 0.6s ease-in-out 0.7s backwards;
    animation: colored-circle 0.6s ease-in-out 0.7s backwards;
}
</style>
